/**
 * getTempUserId
 *
 * Generates a random string of 16 characters to be used as a temporary user id.
 *
 * @returns {string}
 */
function getTempUserId() {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < 16; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * getPrimaryPlayerInGroup
 *
 * Gets the primary player in a group.
 *
 * @param group
 * @returns {{temp_id: null, _id}|null}
 */
const getPrimaryPlayerInGroup = (group) => {
  if (!group || !group.players) {
    return null;
  }

  for (let i = 0; i < group.players.length; i++) {
    if (group.players[i].primary === true) {
      return {
        _id: group.players[i]._id,
        temp_id: group.players[i].temp_id ?? null
      };
    }
  }

  return null;
}

/**
 * daysDiff
 *
 * deprecated
 *
 * Returns the number of days between two dates, regardless of the time.
 * So if d0 is 2011-10-15 23:59:00 and d1 is 2011-10-16 00:01:00, the diff is 1
 * even though the dates are only 2 minutes apart.
 *
 * @param d0
 * @param d1
 * @returns {number}
 */
const daysDiff = (d0, d1) => {

  var msPerDay = 8.64e7;

  // Copy dates so don't mess them up
  var x0 = new Date(d0);
  var x1 = new Date(d1);

  // Set to noon - avoid DST errors
  x0.setHours(12,0,0);
  x1.setHours(12,0,0);

  // Round to remove daylight saving errors
  return Math.round( (x1 - x0) / msPerDay );
}

/**
 * Gets the number of days between the group's date_created and today.
 *
 * It's assumed that group.date_created is a local time to the player (converted to UTC for
 * storage and server-side comparison) set to midnight local time. This is so any day after
 * midnight is considered the next day.
 *
 * i.e.
 * 2023-12-29 23:00:00
 * 2023-12-30 1:00:00
 * is considered 1 day apart even though they are only 2 hours apart and this function will
 * return 2. as on we are on day 2 of the game.
 *
 * @param group
 * @returns {number}
 */
const getGroupDay = (group) => {
  const today = new Date();
  const created = new Date(group.date_created);
  const diff = new Date(today - created);
  return Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
}

export {
  getTempUserId,
  getPrimaryPlayerInGroup,
  getGroupDay
}
